import { Controller } from "@hotwired/stimulus"
import flatpickr from 'flatpickr'
import { Japanese } from "flatpickr/dist/l10n/ja.js"

require("flatpickr/dist/flatpickr.min.css")

export default class extends Controller {
  connect(){
    const input = this.element
    flatpickr(input, {
      showMonths: 1,
      locale: Japanese,
      dateFormat: 'Y/m/d',
      allowInput: true,
      onOpen(_selectedDates, _dateStr, instance) {
        // https://github.com/flatpickr/flatpickr/issues/892#issuecomment-610753460
        // required と readOnly がケンカするのでこっちで付け外し
        instance.element.readOnly = true
      },
      onClose(_selectedDates, _dateStr, instance) {
        instance.element.readOnly = false
      }
    })
  }
}